export default {
  pop_ups: {
    isVisible: false,
    typeClass: "secondary",
    message: "",
  },

  get_data: {
    isVisible: false,
    typeClass: "secondary",
    message: "",
  },

  visitant_form: {
    isVisible: true
  }
};
